/* Domovoi · the evenings you're both free this week, from Home to the products.

   Home (src/week/home.jsx) works out the week; Curated's title page says
   "You're both free from 6:30pm on Thursday and Friday" without loading the
   week itself. Home publishes { today, days: [{ date, from, to, all }] }
   (minutes; freeEvenings() in src/week/helpers.js) each time it computes, and
   a product reads the latest, and `evenings` ({ [date]: { line, both } }, eveningLine()) for
   Catered's Add to a day ("You're out until 10pm"), and `segs` ({ [date]: [[from, to]] }, freeSegs()) —
   all the free time together with nothing planned — for Courted's weather; with children, `couple` (just the two of
   you) and `care` ({ [date]: { free: [[a, b]], with } }: when nobody needs to be with them — at school or with someone
   else — and "Ada’s with Grandparents"), so Courted can say a date out needs a sitter. Nothing is stored: a fresh launch has nothing
   until Home has drawn once, and then the line simply isn't shown.

   Side-effect free: products may import it (see AGENTS.md). */
const KEY = '__dvWeekFree';
const MAX_AGE = 6 * 3600 * 1000;

export function publishFree(summary) {
  if (typeof window === 'undefined') return;
  window[KEY] = { ...summary, at: Date.now() };
  window.dispatchEvent(new CustomEvent('dv-week-free'));
}

export function weekFree() {
  const s = typeof window === 'undefined' ? null : window[KEY];
  return s && Date.now() - s.at < MAX_AGE ? s : null;
}

/** Calls fn() whenever Home publishes again. Returns the unsubscribe. */
export function onWeekFree(fn) {
  window.addEventListener('dv-week-free', fn);
  return () => window.removeEventListener('dv-week-free', fn);
}
